import { Button, RingLoader } from '@basqet-dashboard/common/components';
import { useNavigateTo } from '@basqet-dashboard/common/utils';
import PropTypes from 'prop-types';
import React from 'react';

const PayoutLoadingView = ({ message }) => {
  const { navigateTo } = useNavigateTo();

  return (
    <div className="card">
      <div className="process-info">
        <h3>Processing ...</h3>
        <p className="card__text">{message}</p>
        <RingLoader />
        <Button isFull type="submit" onClick={() => navigateTo('/payouts')}>
          Back to Dashboard
        </Button>
      </div>
    </div>
  );
};

PayoutLoadingView.propTypes = {
  message: PropTypes.string
};

export { PayoutLoadingView };
